import styled from 'styled-components';

const Wrapper = styled.div`
  padding: 0 16px;
  margin-bottom: 20px;
`;

export default { Wrapper };
